export const APPLICATION_ID = '87eb5d9b-ed16-4c54-b6c5-b4ccd4832b92';
export const CLIENT_TOKEN = 'pubd3d59a4478ae4b468bb4f6a7c856a6cb';